import axios from 'axios';

import { DonationURL } from '../../../../../../config/UrlEndPoint';
export const URL = `${DonationURL}thk_kurban`;

//Get By ID
export function getKurbanReportById(kurbanReportId) {
    return axios.get(`${URL}/detail/${kurbanReportId}`);
}

// items => filtered/sorted result for table data
export function findKurbanReport(queryParams) {
    return axios.post(`${URL}/find`, queryParams);
}

export function findArea(queryParams) {
    return axios.post(`${URL}/area/find`, queryParams);
}

export function getLiveStock() {
    return axios.get(`${URL}/livestock`);
}


// items => filtered/sorted result for table data
export function searchKurbanReports(search) {
    return axios.post(`${URL}/search`, search);
}

// POST => POST: Create the kurbanReport on the server
export function createKurbanReport(kurbanReport) {
    return axios.post(URL, kurbanReport);
}

// UPDATE => PUT: update the kurbanReport on the server
export function updateKurbanReport(kurbanReport) {
    return axios.put(`${URL}/${kurbanReport.uuid}`, kurbanReport);
}

// UPDATE => PUT: update the kurbanReport on the server
export function updateStatusKurbanReport(kurbanReport, uuid) {
    return axios.post(`${URL}/update_status/${kurbanReport.uuid ? kurbanReport.uuid : uuid}`, kurbanReport);
}

export function findDistrict(queryParams) {
    return axios.post(`${URL}/location/find`, queryParams);
}

